// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import {
  DatumDefinitionResponseOptionsAPIResponse,
  DatumDefinitionResponseOptionsQuery,
  DatumSearchQuery,
  DatumSearchResponse,
} from '../types';

const { REACT_APP_DATUM_API_URL } = process.env;

// Define a service using a base URL and expected endpoints
export const datumApi = createApi({
  reducerPath: 'datumApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${REACT_APP_DATUM_API_URL}/`,
  }),
  endpoints: (builder) => ({
    searchDefinitions: builder.mutation<DatumSearchResponse, DatumSearchQuery>({
      query: ({ limit = 50, searchTerm }) =>
        `/new_search/?limit=${limit}&columns=coverage_percentage,label&namespace_name=panel:1&search_term=${searchTerm}&search_columns=name&search_columns=varlabel`,
    }),
    getDefinitionResponseOptions: builder.mutation<
      DatumDefinitionResponseOptionsAPIResponse,
      DatumDefinitionResponseOptionsQuery
    >({
      query: ({ panel, definitionId }) =>
        `/namespaces/${panel}/definitions/${definitionId}/responses/`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetDefinitionResponseOptionsMutation, useSearchDefinitionsMutation } = datumApi;
